export default __webpack_public_path__ + "static/Collaborator-796c1f93b984e16ba541974dfb1a4df5.svg";